<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  mounted () {
    console.log('version', 1.1)
    console.log('process.env', process.env)
    this.onMessage()
    // this.initWx()
    // this.fnResize()
    // window.onresize = () => {
    //   this.fnResize()
    // }
  },
  methods: {
    onMessage () {
      let that = this
      window.addEventListener('message', function (event) {
        that.$store.commit('SET_EVENTDATA', event.data)
      }, false)
    },
    initWx () {
      let wx = window.wx
      this.API('wxSignature', {
        uri: location.href.split('#')[0]
      }).then(res => {
        if (res) {
          console.log('微信---------', res)
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline'
            ]
          })
          wx.ready(function () {
            wx.checkJsApi({
              jsApiList: ['chooseImage', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
              success: function (res) {
                console.log(res)
                // 以键值对的形式返回，可用的api值true，不可用为false
                // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              }
            })
          })
          wx.error(function (res) {
            // alert(res.errMsg);
          })
        }
      })
    },
    fnResize () {
      const deviceWidth = document.documentElement.clientWidth || window.innerWidth
      document.documentElement.style.fontSize = (deviceWidth / 3.75) + 'px'
    }
  }
}
</script>

<style lang="scss">
  @import "./assets/style/index";
  .my-weui .weui-toast {
    padding: 17px 44px;
    height: auto;
    width: auto;
  }
  .my-weui .weui-icon_toast {
    display: none;
  }
  body input, body textarea {
    caret-color: auto;
  }
</style>
